var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetroTools(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0275a7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.745,9.563a6.219,6.219,0,0,1-1.3,6.677,5.883,5.883,0,0,1-7.174.981l-1.653,1.844,1.179,1.21.7-.72a.907.907,0,0,1,1.3,0l5.715,5.9a.955.955,0,0,1,0,1.333L24.918,29.45a.907.907,0,0,1-1.3,0l-5.715-5.9a.955.955,0,0,1,0-1.333l.644-.658-1.124-1.151-7.9,8.822a1.816,1.816,0,0,1-2.609,0l-.652-.666a1.913,1.913,0,0,1,0-2.665l9-7.7-5.98-6.126H7.388L5.2,8.48l1.759-1.8,3.594,2.247.023,1.889,6.05,6.2,1.76-1.505a6.209,6.209,0,0,1,.579-7.937,5.905,5.905,0,0,1,6.507-1.34l-3.875,3.9,3.262,3.332,3.883-3.912ZM8.416,26.841a.909.909,0,0,0-1.3,0,.957.957,0,0,0,0,1.333.909.909,0,0,0,1.3,0A.957.957,0,0,0,8.416,26.841Z",
    transform: "translate(-5.203 -5.785)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroTools);
export default __webpack_public_path__ + "static/media/metro-tools.80909edc1549e2bacf1a1a67b0584a2f.svg";
export { ForwardRef as ReactComponent };